









































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
@Component({})
export default class CardModalAksesTindakan extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() pasien!: object;
  @Prop() register!: object;
  // @Prop() namaUnit!: object;
  password = "";
  showEye = false;
  rules = {
    required: (value) => !!value || "Required.",
  };

  get msg() {
    return appModule.msgTtd;
  }
  get stateuser() {
    return userModule.user;
  }
  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit("input", value);
  }

  ttd() {
    if (this.password == "lanjutan") {
      this.show = false;
      this.$emit("kodeAkses");
    } else {
      this.password = "";
    }
  }
  close() {
    this.show = false;
    this.password = "";
    appModule.addMsgTtd("");
    this.$emit("batalAkses");
  }

  @Watch("value")
  changedValue(val) {
    if (!val) {
      this.password = "";
      appModule.addMsgTtd("");
    }
  }
}
